<template>
<div>
</div>
</template>

<script>
import { useClient, useMutation } from 'villus';
import { gql } from 'graphql-tag';
import { computed, reactive } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'updateUserDataWrongPlayedExercisesMutation',

  setup() {
    const store = useStore();

    useClient({
      url: process.env.VUE_APP_STRAPI,
    });

    const updateUserDataWrongPlayedExercisesMutation = gql`
      mutation($id: ID!, $wrongPlayedExercises: JSON!) {
        updateUserData(id: $id, data: { wrongPlayedExercise: $wrongPlayedExercises }) {
          data {
            id
          }
        }
      }
      `;

    const context = reactive({
      headers: computed(() => store.state.auth.headers),
    });

    const { execute: updateUserDataWrongPlayedExercises } = useMutation(updateUserDataWrongPlayedExercisesMutation, {
      context,
    });

    store.commit('setStrapiExecutionHandler', { item: 'updateUserDataWrongPlayedExercises', result: updateUserDataWrongPlayedExercises });
  },
};
</script>
